module.exports = __webpack_public_path__ + "static/media/photographer.f3f5b1cb.jpeg";